import React from 'react';

import Tooltip from '@atlaskit/tooltip';

import * as styles from './filter-dropdown-item-label.styled';

type FilterDropdownItemLabelProps = {
  label: string;
  avatar?: React.ReactNode;
};

export const FilterDropdownItemLabel = (
  props: FilterDropdownItemLabelProps
) => {
  const { avatar, label } = props;
  return (
    <Tooltip content={label} delay={600}>
      <styles.DropdownItemLabelContainer>
        {avatar && (
          <styles.DropdownItemAvatarContainer>
            {avatar}
          </styles.DropdownItemAvatarContainer>
        )}
        <styles.DropdownItemTextContainer>
          {label}
        </styles.DropdownItemTextContainer>
      </styles.DropdownItemLabelContainer>
    </Tooltip>
  );
};
